import CustomAxios from "..";

export const createLandingCard = async (formData) => {
    try {
      const response = await CustomAxios.post(
        `/landing-card/create`,
        formData,
      );
      return response; 
    } catch (error) {
      console.error("Error uploading landing:", error);
      throw error;
    }
};
export const updateLandingCard = async (id,formData) => {
  try {
    const response = await CustomAxios.put(
      `/landing-card/update/${id}`,
      formData,
    );
    return response; 
  } catch (error) {
    console.error("Error uploading landing:", error);
    throw error;
  }
};
  
export const getLandingCard = async (params={}) => {
  try {
    const response = await CustomAxios.get("/landing-card/list",{params});
    return response;
  } catch (error) {
    console.error("Error fetching LandingCard:", error);
    throw error;
  }
};

export const StatusChangeLandingCardById = async (id) => {
  try {
    const response = await CustomAxios.patch(`/landing-card/update-status/${id}`);
    return response;
  } catch (error) {
    console.error("Error fetching LandingCard:", error);
    throw error;
  }
};

export const deleteLandingCardById = async (id) => {
  try {
    const response = await CustomAxios.delete(`/landing-card/${id}`);
    return response;
  } catch (error) {
    console.error("Error fetching LandingCard:", error);
    throw error;
  }
};

